import dayjs, { Dayjs } from 'dayjs';
import { VerificationDateConfig } from 'pages/initiate-due-diligence/types';

export enum VerificationDateSelectedOption {
  Later = 1,
  NoEarlier = 2,
  NoEarlierNoLater = 3,
}

export const hasValidVerificationDateConfig = (
  config: VerificationDateConfig | null | undefined
) => {
  if (!config) {
    return false;
  }

  switch (config.selectedOption) {
    case VerificationDateSelectedOption.Later:
      return config.laterCalculatedDate != null;

    case VerificationDateSelectedOption.NoEarlier:
      return config.noEarlierCalculatedDate != null;

    case VerificationDateSelectedOption.NoEarlierNoLater:
      return (
        Array.isArray(config.noEarlierNoLaterCalculatedDate) &&
        config.noEarlierNoLaterCalculatedDate.length === 2 &&
        config.noEarlierNoLaterCalculatedDate[0] != null &&
        config.noEarlierNoLaterCalculatedDate[1] != null
      );

    default:
      return false;
  }
};

export const isVerificationDateValid = (
  config: VerificationDateConfig,
  dateToValidate: string | number | Date | Dayjs
) => {
  switch (config.selectedOption) {
    case VerificationDateSelectedOption.Later: {
      const minimumAllowedDate = dayjs(config.laterCalculatedDate);

      return dayjs(dateToValidate).isAfter(minimumAllowedDate, 'days');
    }

    case VerificationDateSelectedOption.NoEarlier: {
      const minimumAllowedDate = dayjs(config.noEarlierCalculatedDate);

      return !dayjs(dateToValidate).isBefore(minimumAllowedDate, 'days');
    }

    case VerificationDateSelectedOption.NoEarlierNoLater: {
      const minimumAllowedDate = dayjs(config.noEarlierNoLaterCalculatedDate[0]);
      const maximumAllowedDate = dayjs(config.noEarlierNoLaterCalculatedDate[1]);

      return (
        !dayjs(dateToValidate).isBefore(minimumAllowedDate, 'days') &&
        !dayjs(dateToValidate).isAfter(maximumAllowedDate, 'days')
      );
    }

    default:
      return false;
  }
};

export const getVerificationDateTimeFrameMessage = (config: VerificationDateConfig) => {
  const selectedOption = config.selectedOption;

  switch (selectedOption) {
    case VerificationDateSelectedOption.Later:
      return `later than ${config.later} days`;
    case VerificationDateSelectedOption.NoEarlier:
      return `not earlier than ${config.noEarlier} days`;
    case VerificationDateSelectedOption.NoEarlierNoLater:
      return `not earlier than ${config.noEarlierNoLater[0]} days and not later than ${config.noEarlierNoLater[1]} days`;
    default:
      return '';
  }
};
